//
// AttributeBundle.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "./AttributeType";
import "../util/Dimension";

var AttributeBundle = createModule("commons::AttributeBundle", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getNumberOfOverrides: [4],
        hasStyleAttributeValue: [2,4],
        setStyleAttributeUnsignedValue: [0,4,4],
        getStyleAttributeDimensionValue: [1,4,1],
        clear: [0],
        setStyleAttributeStringValue: [0,4,7],
        getId: [4],
        getStyleAttributeUnsignedValue: [3,4,3],
        setStyleAttributeDimensionValue: [0,4,1],
        getDescription: [7],
        getStyleAttributeBoolValue: [2,4,2],
        getStyleAttributeStringValue: [7,4,7],
        setAttributesOnAttributeBundle: [0,1],
        setAttribute: [0,7,7],
        getAttribute: [7,7],
        setStyleAttributeFloatValue: [0,4,5],
        setParent: [0,1],
        setStyleAttributeBoolValue: [0,4,2],
        hasOverrideForStyleAttribute: [2,4],
        getStyleAttributeFloatValue: [5,4,5],
    },
    {
        _create_v: [4],
        _create_n: [4,4],
        getAttributeParseTypeForStyleAttribute: [4,4],
        isStyleAttributeAColorType: [2,4],
        getAttributeTypeForStyleAttribute: [4,4],
    },
    ,
    ["_create"]
]);
export default AttributeBundle;
